export enum ExtraPackagePayment {
  AT_OFFER_ACCEPTANCE = 'AT_OFFER_ACCEPTANCE',
  AT_ASSIGNMENT_SIGNATURE = 'AT_ASSIGNMENT_SIGNATURE',
}
